import EventListener from 'topmeteo/general/components/EventListener';

import DataList from './DataList';

const Suggestions = ({onClick, onKeyUp, ...props}) => (
    <EventListener target={window} onClick={onClick} onKeyUp={onKeyUp}>
        <DataList {...props} />
    </EventListener>
);

export default Suggestions;
